// extracted by mini-css-extract-plugin
module.exports = {"container":"layout_container___slnX","banner":"layout_banner__Gbsrb"};